import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import { renderInput, renderSelect } from '../../shared/utils/form_components';
import { required } from '../../shared/utils/form_validations';

const ROLE_OPTIONS = [
  { value: 'admin', label: 'admin' },
  { value: 'editor', label: 'editor' }
];

class EditorForm extends Component {

  render() {
    const { handleSubmit, deleteError, error, submitting, deleteButton } = this.props;
    const err = deleteError || error;

    return (
      <Form layout="horizontal" onSubmit={handleSubmit}>

        <Row>
          <Col lg={18} xs={24}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/editors">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Row>
              <Col lg={18} xs={24}>
                <Field
                  name="email"
                  label="Email"
                  placeholder="Email"
                  component={renderInput}
                  validate={required}
                />
              </Col>
              <Col lg={6} xs={24}>
                <Field
                  name="role"
                  label="Role"
                  component={renderSelect}
                  validate={required}
                  options={ROLE_OPTIONS}
                />
              </Col>
            </Row>

          </Col>
        </Row>

      </Form>
    );
  }
}

export default reduxForm({
  form: 'EditorForm',
  initialValues: {
    role: 'editor'
  }
})(EditorForm);
